
































































import WidgetMixins from '../../../../mixins/WidgetMixins';
import Component, { mixins } from 'vue-class-component';
import { currencyFormat, loadWidget } from '@/utils/helpers';
import { Emit, Prop } from 'vue-property-decorator';
import { Getter, namespace } from 'vuex-class';
import { ISettlementReports, PayloadState } from '@/types/types';

import { ValidationObserver, ValidationProvider, extend } from 'vee-validate';
import { numeric, required } from 'vee-validate/dist/rules';

extend('required', {
  ...required,
  message: 'Field is required',
});
extend('numeric', {
  ...numeric,
  message: 'Field accept only numbers',
});
const productsModule = namespace('products');
const customersModule = namespace('customers');
const authModule = namespace('auth');

@Component({
  name: 'TopUpAccountDialog',
  components: {
    EmptyPage: loadWidget('pages/EmptyPage'),
    ValidationObserver,
    ValidationProvider,
    SkeletonPreloader: loadWidget('widgets/SkeletonPreloader'),
  },
  filters: {
    currencyFormat,
  },
})
export default class TopUpAccountDialog extends mixins(WidgetMixins) {
  @Getter('getResetFormState') resetFormState!: boolean;
  @Prop({ default: false, required: true }) state!: boolean;
  @Prop({ default: false }) dialogLoading!: boolean;
  @Prop({ default: false }) loading!: boolean; // button loading
  @Prop({ default: false }) link!: string;
  @Prop({ default: [], required: true }) report!: Array<ISettlementReports>;

  startDateMenu: boolean = false;
  endDateMenu: boolean = false;
  headers: Array<any> = [
    {
      text: 'Date Range',
      align: 'start',
      sortable: false,
      value: 'dateRange',
    },
    { text: 'Org.Name', value: 'organisationName' },
    { text: 'Amount', value: 'totalAmount' },
  ];

  @Emit('save')
  saveData() {
    const [record] = this.report;
    const [startDate, endDate] = record.dateRange?.split('/');
    return {
      loading: {
        idx: 'preview',
        state: false,
      },
      query: {
        startDate,
        endDate,
      },
    };
  }

  @Emit('actions')
  close(): PayloadState {
    return {
      idx: 'preview',
      state: false,
    };
  }
}
